<template>
  <i class="tm-audio" @dblclick="$_editTranscript" v-tm-move="moveObj">
    <tm-audio-span
      v-for="(rectangle, i) in trackRectangles"
      :key="i"
      :track="$props.track"
      :rectangle="rectangle"
      :isFirst="i === 0"
      :isLast="i === trackRectangles.length - 1"
      :isHovered="$data.isHovered"
      :isSelected="isSelected"
      :audioTranscript="audioTranscript"
      :hasAudioWaveForm="hasAudioWaveForm"
      @hovered="$_onHover"
    />

    <tm-audio-resize
      :visible="showResize"
      :fromLeft="true"
      :track="$props.track"
      @hovered="$_onHover"
    />

    <tm-audio-resize
      :visible="showResize"
      :fromRight="true"
      :track="$props.track"
      @hovered="$_onHover"
    />
  </i>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import gridMixin from 'v/Story/Timeline/view/grid.mixin';
import tmBus from 'v/Story/Timeline/api/tmBus';
import tmAudioSpan from './tmAudioSpan.vue';
import tmAudioResize from './tmAudioResize.vue';
import moveAudioInternal from 'v/Story/Timeline/view/movable/moveAudioInternal';
import tmMove from 'v/Story/Timeline/view/movable/tmMove';

export default {
  name: 'tm-audio',
  mixins: [gridMixin, moveAudioInternal],
  directives: { tmMove },
  components: {
    tmAudioSpan,
    tmAudioResize,
  },

  props: {
    track: { type: Object, required: true },
  },

  data() {
    return {
      isHovered: false,
    };
  },

  computed: {
    ...mapGetters('timemachine', ['isDndMode']),
    ...mapState('timemachine', {
      selectedAudio: (state) => state.selected.audio,
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
      MODE_OPTIONAL_AUDIO_INSERT: (state) => state.MODE.OPTIONAL_AUDIO_INSERT,
      MODE_AUDIO_MULTISELECT: (state) => state.MODE.AUDIO_MULTISELECT,
      trackLayer: (state) => state.trackLayer,
      multiSelectIndex: (state) => state.dndEscort.multiSelectIndex,
    }),
    ...mapState({
      storyTranscriptions: (state) => state.story.transcriptions,
      storyAudioWaveForms: (state) => state.story.audioWaveForms,
    }),

    audioTranscript() {
      return (
        this.storyTranscriptions[this.$props.track.data.metadata.assetUUID] ??
        null
      );
    },

    hasAudioWaveForm() {
      return !!this.storyAudioWaveForms[
        this.$props.track.data.metadata.assetUUID
      ];
    },

    isSelected() {
      if (this.MODE_AUDIO_MULTISELECT) {
        const trackIndex = this.trackLayer.audio.indexOf(this.$props.track);
        return trackIndex >= this.multiSelectIndex;
      } else {
        return (
          !!this.selectedAudio &&
          this.selectedAudio.guid === this.$props.track.guid
        );
      }
    },

    /** @note: additional dependency on `grid` defined in gridMixin */
    trackRectangles() {
      if (this.gridEstablished) {
        return this.$_time2rectangles(
          this.$props.track.data.displayStartTime,
          this.$props.track.data.displayEndTime,
          true
        );
      } else {
        return this.$props.track.rectangles;
      }
    },

    showResize() {
      return (
        this.$data.isHovered &&
        !this.$props.track.isResizing &&
        !this.isDndMode &&
        !this.MODE_SCENE_EDIT &&
        !this.MODE_OPTIONAL_AUDIO_INSERT &&
        !this.MODE_AUDIO_MULTISELECT
      );
    },
  },

  watch: {
    // assign rectangles to this.$props.track for cache access
    trackRectangles: {
      immediate: true,
      handler(value) {
        this.$props.track.rectangles = value;
      },
    },
  },

  methods: {
    ...mapActions('timemachine', ['SELECT_AUDIO']),

    $_onHover(hovered, rectangle) {
      this.$data.isHovered = hovered;
      if (hovered) {
        this.$emit('hoveredRectangle', rectangle);
      }
    },

    $_editTranscript: _.debounce(
      function (e) {
        const origin = e.target.closest('.tm-audio-text')
          ? app.TRANSCRIPT_OPENER.TIMELINE_TEXT
          : app.TRANSCRIPT_OPENER.TIMELINE_VO;

        tmBus.$emit('callbackEditTranscript', this.$props.track, origin);
      },
      256,
      { leading: true, trailing: false }
    ),
  },
};
</script>

<style lang="scss">
.tm-tracks-audio > .tm-audio {
  position: absolute;
  top: 0;

  cursor: grab;
}
</style>
